// 파이어베이스 앱 객체 모듈 가져오기
import firebase from 'firebase/compat/app'
// 파이어베이스 패키지 모듈 가져오기
import 'firebase/compat/firestore'
import 'firebase/compat/storage';
import 'firebase/compat/database';
import "firebase/messaging";

import { 
  getAuth, 
  signInWithEmailAndPassword, 
  onAuthStateChanged, 
  signOut,
} from "firebase/auth";

// 파이어스토어 DB를 초기화
firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIRE_API_KEY,
  authDomain: process.env.VUE_APP_FIRE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIRE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIRE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIRE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIRE_SENDER_ID,
  appId: process.env.VUE_APP_FIRE_APP_ID,
  measurementId: process.env.VUE_APP_FIRE_MEASUREMENT_ID
});

// 파이어스토어 스토어 오프라인 캐시 사용
const $f = firebase.firestore()
$f.enablePersistence({
  synchronizeTabs: true // 브라우저 열린 탭과 동기화
}).catch(err => console.log(err))

const oStorage = firebase.storage();

// Notification 푸시용
const oSubscriptionsinDB = firebase.database().ref('subscriptions')
const auth = getAuth()

export { auth, signInWithEmailAndPassword, onAuthStateChanged, $f, signOut }